<template>
  <div
    class="service-area-bd tb"
    v-if="funcView.service_list"
  >
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item style="float:left;">
          <el-button
            v-if="funcView.service_add"
            type="primary"
            icon="el-icon-plus"
            @click="add"
          >{{ funcView.service_add }}</el-button>
        </el-form-item>
        <el-form-item style="float:right;">
          <search-input
            :placeholder="$t('base_serviceArea.xzqmc')"
            v-model="formSearch.search"
            @fetch="onFetch"
          ></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table
        tableCode="service_area"
        :key="tableKey"
        :data="tableList"
        @column="setColumn"
        :index="true"
        @filter="filterChange"
        @sort="sortChange"
        :treeProps="{ children: 'children', hasChildren: 'hasChildren' }"
        rowKey="nationRegionId"
        lazy
        :load="load"
        height="100%"
        ref="table"
      >
        <el-table-column :label="$t('Common.com_handle')">
          <template slot-scope="scope">
            <el-button
              v-if="funcView.service_edit && scope.row.isEdit"
              type="text"
              size="mini"
              @click="edit(scope.row)"
            >{{ funcView.service_edit }}</el-button>
            <el-button
              v-if="funcView.service_delete && scope.row.isEdit"
              type="text"
              size="mini"
              @click="del(scope.row)"
            >{{ funcView.service_delete }}</el-button>
          </template>
        </el-table-column>
      </custom-table>
    </div>
    <area-item-dialog
      v-if="showAreaDialog"
      @close="showAreaDialog = false"
      :nationRegionId="nationRegionId"
      :type="type"
      @create="update"
      @edit="update"
      :model="dialogModel"
      :isTopLevel="dialogModel.isTopLevel"
    ></area-item-dialog>
  </div>
</template>

<script>
import searchInput from '@/components/searchInput.vue';
import apis from '@/utils/apis.js';
import customTable from '@/components/customTable.vue';
import areaItemDialog from './children/area_item_dialog.vue';

export default {
  components: {
    searchInput,
    areaItemDialog,
    customTable,
  },
  data() {
    return {
      formSearch: {
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
        modemState: 0,
      },
      tableList: [],
      totalRows: null,
      showAreaDialog: false,
      nationRegionId: '',
      type: '',
      tableKey: 0,
      dialogModel: {
        title: '',
        isTopLevel: false,
      },
      keyword: '',
    };
  },
  mounted() {

    this.getFuncView();
    this.getTableList();
  },
  methods: {
    // 展开所有行
    expandRows() {
      const list = this.getIcons();
      list.forEach((item) => {
        item.click();
      });
      setTimeout(() => {
        const arr = this.getIcons();
        if (arr.length) {
          this.expandRows();
        }
      }, 50);
    },
    getIcons() {
      const table = this.$refs.table.$refs.tb1;
      const tableEl = table.$el;
      const list = [...tableEl.querySelectorAll('.el-table__expand-icon')].filter((item) => {
        const classList = [...item.classList];
        return !classList.includes('el-table__expand-icon--expanded');
      });
      return list;
    },
    onFetch() {
      this.keyword = this.formSearch.search;
      this.getTableList().then(() => {
        // 通过模糊搜索的结果默认展开
        if (this.keyword) {
          setTimeout(() => {
            this.expandRows();
          }, 50);
        }
      });
    },
    treeNodeFilter(list) {
      list.forEach((item) => {
        item.hasChildren = !!item.isContainChildren;
      });
      return list;
    },
    load(tree, treeNode, resolve) {
      if (this.keyword) {
        resolve(this.treeNodeFilter(tree.children ? tree.children : []));
        return;
      }
      this.$getJSON(apis.NationRegionTree, {
        code: tree.code,
        level: tree.level + 1,
        name: this.formSearch.search,
      }).then((res) => {
        const node = res.data[0];
        resolve(this.treeNodeFilter(node && node.children ? node.children : []));
      });
    },
    getTableList() {
      this.tableKey++; // 清除el-table缓存
      return this.$getJSON(apis.NationRegionTree, this.formSearch.search ? { name: this.formSearch.search } : { level: 1 }).then((res) => {
        this.tableList = this.treeNodeFilter(res.data);
      });
    },
    del(row) {
      const tips = this.$t('base_serviceArea.nqdyscxzdxzqom', [row.name]);
      this.$showConfirm(tips).then(() => {
        const api = `${apis.NationRegionDelete}/${row.nationRegionId}`;
        this.$postJSON(api).then(() => {
          this.$message({
            message: this.$t('Common.com_delete_success'),
            type: 'success',
          });
          this.update();
        });
      });
    },
    edit(row) {
      this.type = 'edit';
      this.nationRegionId = row.nationRegionId;
      this.dialogModel.title = this.$t('base_serviceArea.bjxzq');
      this.dialogModel.isTopLevel = row.level === 1;
      this.showAreaDialog = true;
    },
    add() {
      this.type = 'add';
      this.dialogModel.title = this.$t('base_serviceArea.xzxzq');
      this.showAreaDialog = true;
    },
    update() {
      this.getTableList();
    },
  },
};
</script>

<style></style>
